/* ------------------------------------ */
// Import Images
/* ------------------------------------ */
import img4 from '../images/gallery/4.jpg'
import img5 from '../images/gallery/5.jpg'
import img6 from '../images/gallery/6.jpg'
import img7 from '../images/gallery/7.jpg'
import img8 from '../images/gallery/8.jpg'
import img9 from '../images/gallery/9.jpg'
import img10 from '../images/gallery/10.jpg'
import img11 from '../images/gallery/11.jpg'
import img12 from '../images/gallery/12.jpg'
import img13 from '../images/gallery/13.jpg'
import img14 from '../images/gallery/14.jpg'
import img15 from '../images/gallery/15.jpg'
import img16 from '../images/gallery/16.jpg'
import img17 from '../images/gallery/17.jpg'
import img18 from '../images/gallery/18.jpg'
import img19 from '../images/gallery/19.jpg'
import img20 from '../images/gallery/20.jpg'
import img21 from '../images/gallery/21.jpg'
import img22 from '../images/gallery/22.jpg'
import img23 from '../images/gallery/23.jpg'
import img24 from '../images/gallery/24.jpg'
import img25 from '../images/gallery/25.jpg'

import project1 from '../images/project/1.jpg'
import project2 from '../images/project/2.jpg'
import project3 from '../images/project/3.jpg'
import project4 from '../images/project/4.jpg'
import project5 from '../images/project/5.jpg'

import image_1 from '../../assets/images/gallery/1.jpg'
import image_2 from '../../assets/images/gallery/2.jpg'
import image_3 from '../../assets/images/gallery/3.jpg'


import interior_1 from '../../assets/images/interior/1.jpg'
import interior_2 from '../../assets/images/interior/2.jpg'
import interior_3 from '../../assets/images/interior/3.jpg'
import interior_4 from '../../assets/images/interior/4.jpg'
import interior_5 from '../../assets/images/interior/5.jpg'
import interior_6 from '../../assets/images/interior/6.jpg'
import interior_8 from '../../assets/images/interior/8.jpg'
import interior_9 from '../../assets/images/interior/9.jpg'
import interior_10 from '../../assets/images/interior/10.jpg'
import interior_11 from '../../assets/images/interior/11.jpg'
import interior_12 from '../../assets/images/interior/12.jpg'
import interior_13 from '../../assets/images/interior/13.jpg'
import interior_14 from '../../assets/images/interior/14.jpg'

import corner_1 from '../../assets/images/corner/1.jpg'
import corner_2 from '../../assets/images/corner/2.jpg'
import corner_3 from '../../assets/images/corner/3.jpg'
import corner_4 from '../../assets/images/corner/4.jpg'
import corner_5 from '../../assets/images/corner/5.jpg'
import corner_6 from '../../assets/images/corner/6.jpg'
import corner_8 from '../../assets/images/corner/8.jpg'
import corner_9 from '../../assets/images/corner/9.jpg'
import corner_10 from '../../assets/images/corner/10.jpg'
import corner_11 from '../../assets/images/corner/11.jpg'
import corner_12 from '../../assets/images/corner/12.jpg'
import corner_13 from '../../assets/images/corner/13.jpg'
import corner_14 from '../../assets/images/corner/14.jpg'
import corner_15 from '../../assets/images/corner/15.jpg'
import corner_16 from '../../assets/images/corner/16.jpg'

import decor_1 from '../../assets/images/decor/1.jpg'
import decor_2 from '../../assets/images/decor/2.jpg'
import decor_3 from '../../assets/images/decor/3.jpg'
import decor_4 from '../../assets/images/decor/4.jpg'
import decor_5 from '../../assets/images/decor/5.jpg'
import decor_6 from '../../assets/images/decor/6.jpg'
import decor_8 from '../../assets/images/decor/8.jpg'
import decor_9 from '../../assets/images/decor/9.jpg'
import decor_10 from '../../assets/images/decor/10.jpg'
import decor_11 from '../../assets/images/decor/11.jpg'
import decor_12 from '../../assets/images/decor/12.jpg'
import decor_13 from '../../assets/images/decor/13.jpg'
import decor_14 from '../../assets/images/decor/14.jpg'
import decor_15 from '../../assets/images/decor/15.jpg'
import decor_16 from '../../assets/images/decor/16.jpg'
import decor_17 from '../../assets/images/decor/17.jpg'
import decor_18 from '../../assets/images/decor/18.jpg'
import decor_19 from '../../assets/images/decor/19.jpg'
import decor_20 from '../../assets/images/decor/20.jpg'
import decor_21 from '../../assets/images/decor/21.jpg'
import decor_22 from '../../assets/images/decor/22.jpg'
import decor_23 from '../../assets/images/decor/23.jpg'
import decor_24 from '../../assets/images/decor/24.jpg'
import decor_25 from '../../assets/images/decor/25.jpg'
import decor_26 from '../../assets/images/decor/26.jpg'
import decor_27 from '../../assets/images/decor/27.jpg'
import decor_28 from '../../assets/images/decor/28.jpg'
import decor_29 from '../../assets/images/decor/29.jpg'
import decor_30 from '../../assets/images/decor/30.jpg'
import decor_31 from '../../assets/images/decor/31.jpg'
import decor_32 from '../../assets/images/decor/32.jpg'
import decor_33 from '../../assets/images/decor/33.jpg'
import decor_34 from '../../assets/images/decor/34.jpg'
import decor_35 from '../../assets/images/decor/35.jpg'
import decor_36 from '../../assets/images/decor/36.jpg'

import design_1 from '../../assets/images/design/1.jpg'
import design_2 from '../../assets/images/design/2.jpg'
import design_3 from '../../assets/images/design/3.jpg'
import design_4 from '../../assets/images/design/4.jpg'
import design_5 from '../../assets/images/design/5.jpg'
import design_6 from '../../assets/images/design/6.jpg'
import design_8 from '../../assets/images/design/8.jpg'
import design_9 from '../../assets/images/design/9.jpg'
import design_10 from '../../assets/images/design/10.jpg'
import design_11 from '../../assets/images/design/11.jpg'
import design_12 from '../../assets/images/design/12.jpg'

import concept_1 from '../../assets/images/concept/1.jpg'
import concept_2 from '../../assets/images/concept/2.jpg'
import concept_3 from '../../assets/images/concept/3.jpg'
import concept_4 from '../../assets/images/concept/4.jpg'
import concept_5 from '../../assets/images/concept/5.jpg'
import concept_6 from '../../assets/images/concept/6.jpg'
import concept_8 from '../../assets/images/concept/8.jpg'
import concept_9 from '../../assets/images/concept/9.jpg'

import slidehero_1 from '../../assets/images/slidehero/1.jpg'
import slidehero_2 from '../../assets/images/slidehero/2.jpg'
import slidehero_3 from '../../assets/images/slidehero/3.jpg'
import slidehero_4 from '../../assets/images/slidehero/4.jpg'
import slidehero_5 from '../../assets/images/slidehero/5.jpg'
import slidehero_6 from '../../assets/images/slidehero/6.jpg'

import apollo_1 from '../../assets/images/concept/apollo_1.jpg'
import apollo_2 from '../../assets/images/concept/apollo_2.jpg'
import apollo_3 from '../../assets/images/concept/apollo_3.jpg'
import apollo_4 from '../../assets/images/concept/apollo_4.jpg'
import cool_1 from '../../assets/images/concept/cool_1.jpg'
import cool_2 from '../../assets/images/concept/cool_2.jpg'
import cool_3 from '../../assets/images/concept/cool_3.jpg'
import cool_4 from '../../assets/images/concept/cool_4.jpg'
import igloo_1 from '../../assets/images/concept/igloo_1.jpg'
import igloo_2 from '../../assets/images/concept/igloo_2.jpg'
import igloo_3 from '../../assets/images/concept/igloo_3.jpg'
import igloo_4 from '../../assets/images/concept/igloo_4.jpg'
import jungle_1 from '../../assets/images/concept/jungle_1.jpg'
import jungle_2 from '../../assets/images/concept/jungle_2.jpg'
import jungle_3 from '../../assets/images/concept/jungle_3.jpg'
import notting_1 from '../../assets/images/concept/notting_1.jpg'
import notting_2 from '../../assets/images/concept/notting_2.jpg'
import notting_3 from '../../assets/images/concept/notting_3.jpg'
import notting_4 from '../../assets/images/concept/notting_4.jpg'
import notting_5 from '../../assets/images/concept/notting_5.jpg'
import secret_1 from '../../assets/images/concept/secret_1.jpg'
import secret_2 from '../../assets/images/concept/secret_2.jpg'
import secret_3 from '../../assets/images/concept/secret_3.jpg'
import secret_4 from '../../assets/images/concept/secret_4.jpg'
import secret_5 from '../../assets/images/concept/secret_5.jpg'



/* ------------------------------------ */
// Testi
/* ------------------------------------ */
export const chiSiamo = {
  h1: 'STYLES & FEELINGS',
  h2: () => <><span>Gli stili e i sentimenti ci appartengono</span>: sono le impronte della nostra personalità.</>,
  p: () => { 
    return (
      <>
        Attraverso i nostri progetti di <i>Interiors Design</i> diamo vita alle esigenze e agli stili dei nostri clienti proponendo e realizzando progetti di architettura, design con progettazione stilistica e decorativa su misura di ogni spazio interno ed esterno, definendo l’ideazione del concept che si vuole comunicare, costruendo e progettando lo stile e il logo personalizzato a cui l’ambiente va designato.
        
      </> 
    )
  },
  p2: () => { 
    return (
      <>
       Il design definisce il <i>concept e l’identità</i> che dovrà conferire alla struttura la propria dimensione e soprattutto la propria unicità.<br /><br />

      </> 
    )
  }
}

export const chiSiamoEn = {
  h1: 'STYLES & FEELINGS',
  h2: () => <><span>Styles and Feelings belong to us</span>: they are our fingerprints of our personality.</>,
  p: () => { 
    return (
      <>
Throughout our Interior Design projects, we bring our clients’ décor wishes and styles to life, proposing and realizing our architectural project. We design every single space with art decor by tailored made details reflecting at our client’s styles.         
      </> 
    )
  },
  p2: () => { 
    return (
      <>
All ideas and concepts communicate a specific feeling: we define them with our clients, building up their proper styles and their personal feelings in every ambient and details. <br />
Our Designs Decoration projects define the concept and the identity of our client, conferring a very sense of unicity and structure of a new dimension.</>     
    )
  }
}

export const mission = {
  h2: () => { 
    return (
      <>
        <span>Diamo vita agli stili e alle emozioni</span> di ogni nostro cliente in modo unico e personalizzato.     
      </>
    )},
  p: () => { 
    return (
      <>
        Tale unicità dovrà emergere chiaramente da tutto ciò che concorre a definire il progetto stesso: dalla realizzazione delle opere di ristrutturazione e di ambientazione degli spazi, a quelli di illuminazione, alla definizione dell’arredamento e del brand name e di ogni immagine e logo coordinato.<br/>  
        Diamo spazio alle emozioni e ai sentimenti rispettando i differenti stili perché’ i <i>‘Feelings’</i> dei nostri clienti sono la base fondamentale per iniziare il nostro lavoro.<br/><br/>
        Gli stili e i sentimenti sono ciò che contraddistinguono i nostri progetti come veri e propri segni distintivi del nostro design. 
</> 
    )
  }
}

export const missionEn = {
  h2: () => { 
    return (
      <>
        <span>We give life to new styles and feelings</span> such every different client is. <b>Everybody is unique.</b>     
      </>
    )},
  p: () => { 
    return (
      <>
        This unicity of our décor projects emerges from every single part and details: from the definition of the renovation of spaces to the new setting for them, from the attention of the lighting to the décor and furniture design, from the definition of a new brand to all dimensions and details that should be coordinated. 
        </> 
    )
  }
}

export const project = {
  h2: () => <><span>Ogni nostro progetto è inteso</span> ed è concepito partendo dall’analisi delle emozioni e delle passioni dei nostri clienti.</>,
  p: () => { 
    return (
      <>
        I sentimenti sono espressione della propria individualità e quindi soggettivi come lo stile di ognuno di noi.
      </> 
    )
  },
  p2: () => { 
    return (
      <>       
La progettazione delle nostre proposte nasce dallo studio del <i>concept</i> che il cliente vuole trasmettere: la definizione degli elementi fondamentali di ogni progetto. <br /><br />Lo scopo principale è di fornire le soluzioni <i>eleganti e raffinate</i> ma innovative e rispettose delle emozioni che si vogliono trasmettere. <br/><br />
La nostra esperienza internazionale ci contraddistingue in ogni nostro progetto.
      </> 
    )
  }
}

export const projectEn = {
  h2: () => <><span>Every design project is intended</span> and conceived starting from the analysis of our client’s emotions and passions. </>,
  p: () => { 
    return (
      <>
Our feelings are the expression our individuality and so they’re subjective to each different style we have.       </> 
    )
  },
  p2: () => { 
    return (
      <>       
The design of our projects comes from the study of the <i>concept</i> that every client wants to communicate with our décor. The concept is the fundamental element of our project.  <br /><br />The main scope is to offer <i>different and elegant</i> décor solutions but always innovative and reflecting the state of feelings and emotions that our clients would like to show up. <br/><br />
Our international experience is remarkable in every project. 
      </> 
    )
  }
}

export const conceptText = {
  h2: () => <><span>Ogni ambiente nasce con un concept</span> che costruiamo insieme allo stile e alle necessità dei nostri clienti.</>,
  p: () => { 
    return (
      <>
        I concept esprimono il ruolo che quell’ambiente deve assumere per poter emozionare e tramettere il suo <i>‘significato’</i> nel suo stile.
      </> 
    )
  }
}

export const conceptTextEn = {
  h2: () => <><span>Every space is born from a specific concept</span> that we define together with our clients and their styles and requirements. <b>We communicate this concept with our décor</b></>,
  p: () => { 
    return (
      <>
       Concepts speak up and define the role of every single space to make you feel the emotions and convey  “meaning” in every single style. 
      </> 
    )
  }
}

export const conceptTextArray = [
  {
    id: 'secret',
    title: 'Secret Garden',
    p: () => {
      return (<>
        Nel giardino segreto di Qvinto ogni cosa ti parlerà d'amore.
        <br/><br/>
        Il Secret Garden è la splendida location avvolta da una suggestiva cascata di fiori, dove poter gustare una romantica cena di coppia o un'intima cena tra amici. Momenti 'intimi' da condividere con champagne, rose rosse e tanto amore.
      </> )
    },
    gallery: [
      {
        src: secret_1
      },
      {
        src: secret_2
      },
      {
        src: secret_3
      },
      {
        src: secret_4
      },
      {
        src: secret_5
      },
    ]
  },
  {
    id: 'notting',
    title: 'Notting Hill',
    p: () => {
      return (<>        
        "Can i stay for a while? (Julia Roberts)<br/>You can stay forever (Hugh Grant). "<br/><br/>
        Un angolo di un magico giardino di Londra a Roma... a una porta da te.<br/>
        Il nuovo dehor esterno di Qvinto, in perfetto British Style, dove gustare tutte le prelibatezze degli Chef e i drink firmati dai bartender. Il NottingHill Garden ti avvolgere grazie alla sua sugestiva bellezza e romanticismo.
      </> )
    },
    gallery: [      
      {
        src: notting_1
      },
      {
        src: notting_2
      },
      {
        src: notting_3
      },
      {
        src: notting_4
      },
      {
        src: notting_5
      },
    ]
  },
  {
    id: 'apollo',
    title: 'Apollo & The Roof',
    p: () => {
      return (<>       
       Vivi la tua esperienza spaziale. Allaccia le cinture e preparati al decollo.<br/><br/>
        Il viaggio verso la tua Exclusive Space Experience sta per iniziare.
      </> )
    },
    gallery: [
      {
        src: apollo_1
      },
      {
        src: apollo_2
      },
      {
        src: apollo_3
      },
      {
        src: apollo_4
      },
    ]
  },
  {
    id: 'jungle',
    title: 'Jungle Garden',
    p: () => {
      return (<>
       Il giardino di Qvinto sta per fiorire e diventare un bellissimo paradiso tropicale.<br/><br/>
        Privè unici per un'esperienza ancora più different. Uno speciale angolo di 'giungla' pensato per la notte magica di Qvinto Restaurant. Un'esperienza intima, riservata e immersa nel verde.
      </> )
    },
    gallery: [      
    {
      src: jungle_1
    },
    {
      src: jungle_2
    },
    {
      src: jungle_3
    },
    ]
  },
  {
    id: 'cool',
    title: 'Cool Garden',
    p: () => {
      return (<>
       Comodità, eleganza e bellezza 100% naturale.<br/><br/>
       Un vero e proprio Eden dove gustare i drink dei bartender, godersi un aperitivo o un after dinner al fresco del Parco di Tor di Quinto. Una location sempre fiorita.<br/>
       Il giardino estivo più 'cool' di sempre dove vivere food experience di altissimo livello.
      </> )
    },
    gallery: [
      {
        src: cool_1
      },
      {
        src: cool_2
      },
      {
        src: cool_3
      },
      {
        src: cool_4
      },
    ]
  },
  {
    id: 'igloo',
    title: 'Igloo Garden',
    p: () => {
      return (<>
      Come in una baita a più di 2000 metri, gli Igloo sono la location 'calda' e ideale per vivere l'inverno nella Capitale.<br/><br/>
      Eleganti e confortevoli, gli Igloo sono la cornice ideale dove gustare light lunch, aperitivi gourmet e sorseggiare il vero English Royal Tea.
      </> )
    },
    gallery: [      
    {
      src: igloo_1
    },
    {
      src: igloo_2
    },
    {
      src: igloo_3
    },
    {
      src: igloo_4
    },
    ]
  }
]

export const projectArray = [
  {
    id: 1,
    src: project1,
    caption: 'Interior Design',
    href: '/project/interior'
  },
  {
    id: 2,
    src: project2,
    caption: 'Concept',
    href: '/project/concept'
  },
  {
    id: 3,
    src: project3,
    caption: 'Decor',
    href: '/project/decor'
  },
  {
    id: 4,
    src: project4,
    caption: 'Logo Design',
    href: '/project/design'
  },
  {
    id: 5,
    src: project5,
    caption: 'Corner',
    href: '/project/corner'
  },
]

export const slideShow = [
  {
    id: 1,
    src: img4,
    caption: ''
  },
  {
    id: 2,
    src: img5,
    caption: ''
  },
  {
    id: 3,
    src: img6,
    caption: ''
  },
  {
    id: 4,
    src: img7,
    caption: ''
  },
  {
    id: 5,
    src: img8,
    caption: ''
  },
  {
    id: 6,
    src: img9,
    caption: ''
  },
  {
    id: 7,
    src: img10,
    caption: ''
  },
  {
    id: 8,
    src: img11,
    caption: ''
  },
  {
    id: 9,
    src: img12,
    caption: ''
  },
  {
    id: 10,
    src: img13,
    caption: ''
  },
  {
    id: 11,
    src: img14,
    caption: ''
  },
  {
    id: 12,
    src: img15,
    caption: ''
  },
  {
    id: 13,
    src: img16,
    caption: ''
  },
  {
    id: 14,
    src: img17,
    caption: ''
  },
  {
    id: 15,
    src: img18,
    caption: ''
  },
  {
    id: 16,
    src: img19,
    caption: ''
  },
  {
    id: 17,
    src: img20,
    caption: ''
  },
  {
    id: 18,
    src: img21,
    caption: ''
  },
  {
    id: 19,
    src: img22,
    caption: ''
  },
  {
    id: 20,
    src: img23,
    caption: ''
  },
  {
    id: 21,
    src: img24,
    caption: ''
  },
  {
    id: 22,
    src: img25,
    caption: ''
  }
]

export const gallery = [
  {
      id: 1,
      src: image_1
  },
  {
      id: 2,
      src: image_2
  },
  {
      id: 3,
      src: image_3
  },
];

export const slidehero = [
  {
    id: 1,
    src: slidehero_1
},
{
    id: 2,
    src: slidehero_2
},
{
    id: 3,
    src: slidehero_3
},
{
  id: 4,
  src: slidehero_4
},
{
  id: 5,
  src: slidehero_5
},
{
  id: 6,
  src: slidehero_6
},
]

export const interior = [
  {
      id: 1,
      src: interior_1
  },
  {
      id: 2,
      src: interior_2
  },
  {
      id: 3,
      src: interior_3
  },
  {
    id: 4,
    src: interior_4
  },
  {
    id: 5,
    src: interior_5
  },
  {
    id: 6,
    src: interior_6
  },
  {
    id: 8,
    src: interior_8
  },
  {
    id: 9,
    src: interior_9
  },
  {
    id: 10,
    src: interior_10
  },
  {
    id: 11,
    src: interior_11
  },
  {
    id: 12,
    src: interior_12
  },
  {
    id: 13,
    src: interior_13
  },
  {
    id: 14,
    src: interior_14
  },
];

export const decor = [
  {
      id: 1,
      src: decor_1
  },
  {
      id: 2,
      src: decor_2
  },
  {
      id: 3,
      src: decor_3
  },
  {
    id: 4,
    src: decor_4
  },
  {
    id: 5,
    src: decor_5
  },
  {
    id: 6,
    src: decor_6
  },
  {
    id: 8,
    src: decor_8
  },
  {
    id: 9,
    src: decor_9
  },
  {
    id: 10,
    src: decor_10
  },
  {
    id: 11,
    src: decor_11
  },
  {
    id: 12,
    src: decor_12
  },
  {
    id: 13,
    src: decor_13
  },
  {
    id: 14,
    src: decor_14
  },
  {
    id: 15,
    src: decor_15
  },
  {
    id: 16,
    src: decor_16
  },
  {
    id: 16,
    src: decor_16
  },{
    id: 17,
    src: decor_17
  },{
    id: 18,
    src: decor_18
  },{
    id: 19,
    src: decor_19
  },{
    id: 20,
    src: decor_20
  },{
    id: 21,
    src: decor_21
  },{
    id: 22,
    src: decor_22
  },{
    id: 23,
    src: decor_23
  },{
    id: 24,
    src: decor_24
  },{
    id: 25,
    src: decor_25
  },{
    id: 26,
    src: decor_26
  },{
    id: 27,
    src: decor_27
  },
  {
    id: 28,
    src: decor_28
  },
  {
    id: 29,
    src: decor_29
  },
  {
    id: 30,
    src: decor_30
  },
  {
    id: 31,
    src: decor_31
  },
  {
    id: 32,
    src: decor_32
  },
  {
    id: 33,
    src: decor_33
  },
  {
    id: 34,
    src: decor_34
  },
  {
    id: 35,
    src: decor_35
  },
  {
    id: 36,
    src: decor_36
  },
];

export const corner = [
  {
      id: 1,
      src: corner_1
  },
  {
      id: 2,
      src: corner_2
  },
  {
      id: 3,
      src: corner_3
  },
  {
    id: 4,
    src: corner_4
  },
  {
    id: 5,
    src: corner_5
  },
  {
    id: 6,
    src: corner_6
  },
  {
    id: 8,
    src: corner_8
  },
  {
    id: 9,
    src: corner_9
  },
  {
    id: 10,
    src: corner_10
  },
  {
    id: 11,
    src: corner_11
  },
  {
    id: 12,
    src: corner_12
  },
  {
    id: 13,
    src: corner_13
  },
  {
    id: 14,
    src: corner_14
  },
  {
    id: 15,
    src: corner_15
  },
  {
    id: 16,
    src: corner_16
  },
];

export const design = [
  {
      id: 1,
      src: design_1
  },
  {
      id: 2,
      src: design_2
  },
  {
      id: 3,
      src: design_3
  },
  {
    id: 4,
    src: design_4
  },
  {
    id: 5,
    src: design_5
  },
  {
    id: 6,
    src: design_6
  },
  {
    id: 8,
    src: design_8
  },
  {
    id: 9,
    src: design_9
  },
  {
    id: 10,
    src: design_10
  },
  {
    id: 11,
    src: design_11
  },
  {
    id: 12,
    src: design_12
  },
];

export const concept = [
  {
      id: 1,
      src: concept_1
  },
  {
      id: 2,
      src: concept_2
  },
  {
      id: 3,
      src: concept_3
  },
  {
    id: 4,
    src: concept_4
  },
  {
    id: 5,
    src: concept_5
  },
  {
    id: 6,
    src: concept_6
  },
  {
    id: 8,
    src: concept_8
  },
  {
    id: 9,
    src: concept_9
  },
];
